import "./names.css";
import { useState, useEffect } from "react";
import { AiFillCopy } from 'react-icons/ai';
import CopyNames from "./CopyNames";
import SearchUser from "../searchUser/SearchUser";
import Massage from "../../design/Massage";
import IconDiv from "../../design/IconDiv";
import AppNewName from '../newName/AppNewName';
import NamesTable from "./NamesTable";
import { fetchPostDocket } from "../../../faetures/fetch";


export default function AppNames ({names, setNames, reset, numOfDocket, setNamesAfterDelete}) {
    const [newUser, setNewUser] = useState({num: 0, close: false});
    /** Clicking on a name adds it to the list. To delete or copy multiple names, the first contains the client's ID, and the second contains the server's ID. */
    const [clcikEnable, setClickEnable] = useState([[], []]); 
    const [massage, setMassage] = useState({text: '', open: false, agree: true});
    const [search, setSearch] = useState({open: false, firstName: '', lastName: ''});

    useEffect(() => {
        setNewUser({num: 0, close: false});
        setClickEnable([[], []]);
        setMassage({text: '', open: false, agree: true});
    }, [reset])

    function deleteNames (namesList) {
        const names2 = names;
        for (let i of namesList) {
            delete names2[i]; 
        }
        setNamesAfterDelete(names2); // delete names in client
    }

    const deleteAfterAgree = () => {
        setMassage({text: '', open: true, agree: false});
        fetchPostDocket('delete-names', {num: numOfDocket, names: clcikEnable[1]}).then((resolve) => {
            if (resolve === 'okay') {
                deleteNames(clcikEnable[1]);
                setMassage({text: 'שמות נמחקו', open: true, agree: false});
                setClickEnable([[], []]);
            } else {
                setMassage({text: 'שגיאה ! שמות לא נמחקו', open: true, agree: false});
            }
        }).catch(() => {
            setMassage({text: 'שגיאה בשרת ! נסה בעוד כמה דקות', open: true, agree: false});
        })
    }
    
    const style = {background: '-webkit-linear-gradient(#858484, #333)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'};

    return (<>
    <div style={{'height': '100%'}} >
        <div className="namesHeader">
            <IconDiv 
            icon={"add"} 
            pStyle={style}
            onClick = {() => setNewUser({num: 0, data: {}, close: true})}
            />
            <IconDiv 
            icon={"search"} 
            pStyle={style}
            onClick = {() => setSearch({open: true, firstName: '', lastName: ''})}
            />
            <IconDiv 
            icon={"delete"} 
            pStyle={style}
            onClick={() => {
                clcikEnable.length && setMassage({open: true, text: 'האם אתה בטוח שברצונך למחוק', agree: true})
            }}
            />
            <div className="IconDiv">
                <AiFillCopy 
                className="icon-1"
                />
                <select>
                    <option value={1}> העתק הכל לאמדאוס </option>
                    <option value={2}> העתק מסומנים לאמדאוס </option>
                </select>
            </div>
        </div>

        <NamesTable 
        namesList={names} 
        onDoubleClick={(key, data) => setNewUser({num: key, close:true})}
        clcikEnable={clcikEnable}
        setClickEnable={setClickEnable}
        />

    </div>

    { massage.open && (massage.agree ?
        <Massage 
        text={massage.text}
        buttonAgree={deleteAfterAgree}
        setClose={() => setMassage({text: '', open: false})} 
        /> :
        <Massage
        text={massage.text}
        animation={true}
        setClose={() => setMassage({text: '', open: false, agree: true})}
        />)
    }

    { newUser.close && 
        <AppNewName 
        setClose={() => setNewUser({...newUser, close: false})} 
        numOfUser={newUser.num}
        setNumOfUser={(num) => setNewUser({num: num, close: true})}
        setNames={setNames}
        names={names}
        numOfDocket={numOfDocket}
        setNamesSearch={(fn, ln) => setSearch({open: true, firstName: fn, lastName: ln})}
        deleteNamesInClient={deleteNames}
        /> 
    }

    { search.open && 
        <SearchUser 
        setClose={() => setSearch({open: false, firstName: '', lastName: ''})} 
        firstName={search.firstName} 
        lastName={search.lastName}
        setNamesMy={setNames}
        numDocket={numOfDocket}
        />
    }
    </>)
}